var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryAddBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010412;}\n\t.st1{fill:#3955BF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.4,9.9h-5.7V4.2c0-1.2-1-2.1-2.1-2.1s-2.1,1-2.1,2.1v5.7h-5.7c-1.2,0-2.1,1-2.1,2.1s1,2.1,2.1,2.1h5.7v5.7 c0,1.2,1,2.1,2.1,2.1s2.1-1,2.1-2.1v-5.7h5.7c1.2,0,2.1-1,2.1-2.1S59.6,9.9,58.4,9.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.6,20.6c0,4.3,3.5,7.8,7.8,7.8s7.8-3.5,7.8-7.8s-3.5-7.8-7.8-7.8S15.6,16.3,15.6,20.6z M27,20.6 c0,2-1.6,3.6-3.6,3.6s-3.6-1.6-3.6-3.6s1.6-3.6,3.6-3.6S27,18.6,27,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.5,24.2c-1.2,0-2.1,1-2.1,2.1v6.5l-1.1-1c-3-2.6-7.8-2.6-10.8,0L34.6,42c-1.4,1.2-3.8,1.2-5.2,0l-1-0.8 c-2.7-2.4-7.1-2.6-10.1-0.6L6.5,48.5c-0.6-2.2-0.8-4.8-0.8-8V23.4c0-13.2,4.7-17.8,17.8-17.8h11.4c1.2,0,2.1-1,2.1-2.1 s-1-2.1-2.1-2.1H23.4C7.9,1.3,1.3,7.9,1.3,23.4v17.1c0,15.5,6.6,22.1,22.1,22.1h17.1c15.5,0,22.1-6.6,22.1-22.1V26.3 C62.7,25.1,61.7,24.2,60.5,24.2z M40.6,58.4H23.4c-7.9,0-12.7-1.7-15.3-5.8l12.5-8.4c1.5-1,3.6-0.9,4.9,0.2l1,0.8 c3,2.6,7.8,2.6,10.8,0L49.2,35c1.4-1.2,3.8-1.2,5.3,0l3.9,3.4v2.2C58.4,53.7,53.7,58.4,40.6,58.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryAddBlack);
export default __webpack_public_path__ + "static/media/gallery-add-black.aa2870e193bc3a6ef7ee2be6978f7636.svg";
export { ForwardRef as ReactComponent };